import React, { useEffect, useState } from 'react'
import { Client, Databases, Query } from "appwrite";
import Footer from '../footer';

const client = new Client();

client
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('65a105b7ac26a63b4779');

export default function Css() {
    const databases = new Databases(client);

    let promise = databases.listDocuments(
        "65a106540e177077ef01",
        "65a10663880b2fdd291f",
    );
    let [data, newdata] = useState([])
    useEffect(() => {
        promise.then(function (response) {
            let newlist = response.documents.length - 5
            let newobject = response.documents[newlist]
            newdata(newobject)
        }, function (error) {
            console.log(error);
        });
    })

    return (
        <>
            <div className="container"><br />
                <h1 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bold', textShadow: '0px 20px 20px black' }}>{data.Title}</h1><br />
                <img src={data.Image} alt="" className='imgsection' style={{ display: 'block', margin: 'auto', boxShadow: '0px 20px 30px black' }} /><br /><br /><br />
                <p><div dangerouslySetInnerHTML={{ __html: data.Content }}></div></p><br />
                <form action="/"><button className='btn btn-primary'>Go Back</button></form><br /><br /><br />
            </div>
            <Footer />
        </>
    )
}